import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { buyingPowerSummaryModel } from './buyingPowerSummary.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceStock } from '../../../service-stock.service';
import { NumericFilterPipe } from '../../../numeric-filter.pipe';
import { HttpResponse } from '@angular/common/http';
import { InvestoridComponent } from '../../../gotx/components/Investorid/Investorid.component';
import { GotxTableComponent } from '../../../gotx/components/gotx-table/gotx-table.component';
import { gotxModalComponent } from '../../../gotxModal/gotxModal.component';
import { ProductComponent } from '../../components/Product/Product.component';
import { MarginComponent } from '../../../gotx/components/Margin/Margin.component';

const customCss: string = 'a{  text-decoration: none;  color:blue;  cursor: pointer  }';

@Component({
  selector: 'app-buyingPowerSummary',
  templateUrl: './buyingPowerSummary.component.html'
})

export class buyingPowerSummaryComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('cstmInvestorID', { static: false }) cstmInvestorID: InvestoridComponent;
  @ViewChild('btnBuyingPowerSummarySubmit', { static: false }) btnBuyingPowerSummarySubmit: ButtonComponent;
  @ViewChild('buyingPowerSummary_gotxTable', { static: false }) buyingPowerSummary_gotxTable: GotxTableComponent;
  //@ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  @ViewChild('cstmMargin', { static: false }) cstmMargin: MarginComponent;
  @Output() selectedRow = new EventEmitter<String>();
  format = '2.2-2';
  respObj: any;
  textAlign: any;
  tableRows: any;
  buyingPowerGrid: { [k: string]: any } = {};
  selectedMenu = '';
  menu_model_header = '';
  skeletonContentLoaded = false;
  marginSelected: any;

  displayTitle = false;   //To Hide the Title of the screen
  buyingPowerGridMarginVal: number = 0;
  buyingPowerGridBuyingVal: number = 0;

  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      this.cstmInvestorID.revalidate(),
      this.cstmMargin.revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock, private modalService: NgbModal, private filter: NumericFilterPipe) {
    super(services);
    this.value = new buyingPowerSummaryModel();
    this.componentCode = 'buyingPowerSummary';
    this.displayBorder = false;
    this.buyingPowerGrid.closingClearedCash = 0.00;
    this.buyingPowerGrid.marginReleased = 0.00;
    this.buyingPowerGrid.equitySalesProceed = 0.00;
    this.buyingPowerGrid.equityTradingGains = 0.00;
    this.buyingPowerGrid.stocksale = 0.00;
    this.buyingPowerGrid.creditAgainstStock = 0.00;
    this.buyingPowerGrid.againstStocks = 0.00;
    this.buyingPowerGrid.marginUsage = 0.00;
    this.buyingPowerGrid.equityPurchase = 0.00;
    this.buyingPowerGrid.equityTradingLosses = 0.00;
    this.buyingPowerGrid.equityMarginHeld = 0.00;
    this.buyingPowerGrid.foMarginHeld = 0.00;
    this.buyingPowerGrid.purchase = 0.00;
    this.buyingPowerGrid.salesProceed = 0.00;
    this.buyingPowerGrid.marginAvailable = 0.00;
    this.buyingPowerGrid.debtSalesProceed = 0.00;
    this.buyingPowerGrid.debtTradingGains = 0.00;
    this.buyingPowerGrid.futureTradingGains = 0.00;
    this.buyingPowerGrid.optionPremiumRcvd = 0.00;
    this.buyingPowerGrid.debtPurchase = 0.00;
    this.buyingPowerGrid.debtTradingLosses = 0.00;
    this.buyingPowerGrid.foTradingLosses = 0.00;
    this.buyingPowerGrid.optionPremiumsPaid = 0.00;
    this.buyingPowerGrid.debtMarginHeld = 0.00;
    this.buyingPowerGrid.purchase = 0.00;
    this.buyingPowerGrid.salesProceed = 0.00;
    this.buyingPowerGrid.marginHeld = 0.00;
    this.buyingPowerGridMarginVal = 0.00;
    this.buyingPowerGridBuyingVal = 0.00;
    this.buyingPowerGrid.foMarginHeld = 0.00;
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
    this.cstmInvestorID.setReadOnly(readOnly);
    this.cstmMargin.setReadOnly(readOnly);
  }
  async onFormLoad() {
    this.marginSelected = this.cstmMargin.cmbMargin.getFieldValue();
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    // this.cstmInvestorID.cmbInvestorId.setFocus(true);
    this.btnBuyingPowerSummarySubmit.setFocus(true);
    this.setDependencies();
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'buyingPowerSummary';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.additionalInfo['cstmInvestorID_desc'] = this.cstmInvestorID.getFieldInfo();
    this.additionalInfo['cstmMargin_desc'] = this.cstmMargin.getFieldInfo();
    return this.additionalInfo;
  }
  getFieldValue() {
    this.value.cstmInvestorID = this.cstmInvestorID.getFieldValue();
    this.value.cstmMargin = this.cstmMargin.getFieldValue();
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.cstmInvestorID.setValue(inputValue['cstmInvestorID'], inputDesc['cstmInvestorID_desc']);
    this.cstmMargin.setValue(inputValue['cstmMargin'], inputDesc['cstmMargin']);
    this.value = new buyingPowerSummaryModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'buyingPowerSummary'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'buyingPowerSummary_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
    this.onSetGrid();
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('buyingPowerSummary_customCss');
    styleElement.parentNode.removeChild(styleElement);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.value.cstmInvestorID = this.cstmInvestorID.getFieldValue();
      this.cstmInvestorID.valueChangeUpdates().subscribe((value) => { this.value.cstmInvestorID = value; });
      this.value.cstmMargin = this.cstmMargin.getFieldValue();
      this.cstmMargin.valueChangeUpdates().subscribe((value) => { this.value.cstmMargin = value; });
      this.onFormLoad();
      this.checkForHTabOverFlow();
      this.fetchDataFromServer();

    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.cstmInvestorID.clearError();
    this.cstmMargin.clearError();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.cstmInvestorID.onReset();
    this.cstmMargin.onReset();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new buyingPowerSummaryModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async marginSelectedChange(event) {
    this.marginSelected = this.cstmMargin.cmbMargin.getFieldValue();
    this.fetchDataFromServer();
    this.onSetGrid();
}

  async btnBuyingPowerSummarySubmit_click(event) {
    this.fetchDataFromServer();
  }
  async fetchDataFromServer() {
    let inputMap = new Map();
    this.onSetGrid();
    var errorCount: number = await this.revalidate();
    document.getElementById('errMsgDiv').innerHTML = "";

    if (errorCount == 0) {
      inputMap.clear();
     // inputMap.set('Body.marginGroupNo', this.services.dataStore.getData("setmarginGroupList"));
      //inputMap.set('Body.product', this.services.dataStore.getData("productID"));
      //inputMap.set('Body.marginGroupNo', "COMDERV");
      inputMap.set('Body.marginGroupNo', this.cstmMargin.cmbMargin.getFieldValue());
      //inputMap.set('Body.product', this.cstmProduct.cmbProduct.getFieldValue());
      inputMap.set('Body.clientid', this.cstmInvestorID.cmbInvestorId.getFieldValue());
      this.services.http.fetchApi('/statements/margin', 'POST', inputMap).subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          var respCode: any = res['respCode'];

          this.respObj = res['response'];
          if (respCode != null && respCode == 0) {

            // Start - Margin Calc
            var calculateIntradayEquityAs = "", calculateDeliveryEquityAs = "";
            var aValue = this.respObj.marginStatementlist[0].closingClearedCash;
            var bValue = this.respObj.marginStatementlist[0].marginReleased;
            var cValue = this.respObj.marginStatementlist[0].creditAgainstStock;
            var dValue = this.respObj.marginStatementlist[0].againstStocks;
            var eValue = this.respObj.marginStatementlist[0].marginUsage;
            // if(this.respObj.marginLimitEntryList[0][1].intradayFlag == 'N'.charCodeAt(0)) {
            //   calculateIntradayEquityAs = "A+B-E";
            //   this.buyingPowerGridMarginVal = aValue+bValue+eValue;
            // }
            // else if(this.respObj.marginLimitEntryList[0][1].intradayFlag == 'C'.charCodeAt(0)) {
            //   calculateIntradayEquityAs = "A+B+C-E";
            //   this.buyingPowerGridMarginVal = aValue+bValue+cValue+eValue;
            // }
            // else if(this.respObj.marginLimitEntryList[0][1].intradayFlag == 'S'.charCodeAt(0)) {
            //   calculateIntradayEquityAs = "A+B+D-E";
            //   this.buyingPowerGridMarginVal = aValue+bValue+dValue+eValue;
            // }
            // else if(this.respObj.marginLimitEntryList[0][1].intradayFlag == 'A'.charCodeAt(0)) {
            //   calculateIntradayEquityAs = "A+B+C+D-E";
            //   this.buyingPowerGridMarginVal = aValue+bValue+cValue+dValue+eValue;
            // }
            //this.buyingPowerGridBuyingVal = this.respObj.marginLimitEntryList[0][1].deliveryCFLimits;
            if(this.marginSelected == 1){
            if(this.respObj.marginLimitEntryList[0][1].deliveryFlag == 'N'.charCodeAt(0)) {
              calculateDeliveryEquityAs = "A+B-E";
              this.buyingPowerGridMarginVal = aValue+bValue+eValue;
            }
            else if(this.respObj.marginLimitEntryList[0][1].deliveryFlag == 'C'.charCodeAt(0)) {
              calculateDeliveryEquityAs = "A+B+C-E";
              this.buyingPowerGridMarginVal = aValue+bValue+cValue+eValue;
            }
            else if(this.respObj.marginLimitEntryList[0][1].deliveryFlag == 'S'.charCodeAt(0)) {
              calculateDeliveryEquityAs = "A+B+D-E";
              this.buyingPowerGridMarginVal = aValue+bValue+dValue+eValue;
            }
            else if(this.respObj.marginLimitEntryList[0][1].deliveryFlag == 'A'.charCodeAt(0)) {
              calculateDeliveryEquityAs = "A+B+C+D-E";
              this.buyingPowerGridMarginVal = aValue+bValue+cValue+dValue+eValue;
            }
            this.buyingPowerGridBuyingVal = this.respObj.marginLimitEntryList[0][1].deliveryCFLimits;
            //         
            this.buyingPowerGridBuyingVal = this.buyingPowerGridBuyingVal / 10000;
            // End - Margin Calc

          }else{
            if(this.respObj.marginLimitEntryList[0][0].deliveryFlag == 'N'.charCodeAt(0)) {
              calculateDeliveryEquityAs = "A+B-E";
              this.buyingPowerGridMarginVal = aValue+bValue+eValue;
            }
            else if(this.respObj.marginLimitEntryList[0][0].deliveryFlag == 'C'.charCodeAt(0)) {
              calculateDeliveryEquityAs = "A+B+C-E";
              this.buyingPowerGridMarginVal = aValue+bValue+cValue+eValue;
            }
            else if(this.respObj.marginLimitEntryList[0][0].deliveryFlag == 'S'.charCodeAt(0)) {
              calculateDeliveryEquityAs = "A+B+D-E";
              this.buyingPowerGridMarginVal = aValue+bValue+dValue+eValue;
            }
            else if(this.respObj.marginLimitEntryList[0][0].deliveryFlag == 'A'.charCodeAt(0)) {
              calculateDeliveryEquityAs = "A+B+C+D-E";
              this.buyingPowerGridMarginVal = aValue+bValue+cValue+dValue+eValue;
            }
            this.buyingPowerGridBuyingVal = this.respObj.marginLimitEntryList[0][0].deliveryCFLimits;
            //         
            this.buyingPowerGridBuyingVal = this.buyingPowerGridBuyingVal / 10000;
            // End - Margin Calc
          }
 
          
            this.buyingPowerGrid = this.respObj.marginStatementlist[0];
            this.onSetGrid();
          }
          else {
            //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
	    //commented by Shanmuga Priya - VAPT
            const rawMsg = res['errMsg'];
            const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
            (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;

          }
          
        },
        async (httpError) => {
          var err = httpError['error']
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
            if (err['ErrorElementPath'] == 'clientid') {
              this.cstmInvestorID.cmbInvestorId.setError(err['ErrorDescription']);
            }
          }
          document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');

        }
      );
    }
  }
  transalte(text) {
    return this.services.translate.instant(text);
  }
  fieldDependencies = {
  }

  onSetGrid() {
    // console.log("functionCall")
    // let res = { "respCode": "0", "errMsg": "", "response": { "marginStatementlist": [{ "closingClearedCash": 1000000.0, "marginReleased": 20.0, "againstCashReceivables": 0.0, "againstStocks": 600.0, "credits": 0.0, "creditAgainstStock": 30.0, "stocksale": 0.0, "marginUsage": -10375017.2, "cashPayables": 0.0, "equityPurchase": 0.0, "optionPremiumsPaid": 0.0, "equityTradingLosses": 0.0, "foTradingLosses": 0.0, "marginHeld": -10375017.2, "equityMarginHeld": -10375017.2, "foMarginHeld": 0.0, "mtmNotionalLoss": 0.0, "marginAvailable": -9375017.2, "marginavailable": -9375017.2, "equitySalesProceed": 0.0, "optionPremiumRcvd": 0.0, "equityTradingGains": 0.0, "futureTradingGains": 0.0, "intradayTradingLimits": null, "deliveryTradingLimits": null, "fotradingLimits": null, "cashBlocked": null, "freeCashAvailable": null, "marginStatementList": null, "exchange": null, "currencyTradingLosses": 0.0, "currencyTradingGains": 0.0, "currencyMarginHeld": 0.0, "commodityTradingLosses": 0.0, "commodityTradingGains": 0.0, "commodityMarginHeld": 0.0, "debtTradingLosses": 0.0, "debtTradingGains": 0.0, "debtMarginHeld": 0.0, "debtSalesProceed": 0.0, "debtPurchase": 0.0, "onlyEquity": null }], "marginLimitEntryList": [[{ "product": "OQA=", "intradayFlag": 78, "deliveryFlag": 65, "intradayLimits": 0, "deliveryCFLimits": -93750172000, "tradingGainM": 0, "tradingLossM": 0, "marginHeldM": 0, "salesProceed": 0, "purchase": 0 }, { "product": "NQA=", "intradayFlag": 78, "deliveryFlag": 65, "intradayLimits": 0, "deliveryCFLimits": -93750172000, "tradingGainM": 0, "tradingLossM": 0, "marginHeldM": -103750172000, "salesProceed": 0, "purchase": 0 }]], "showExchangeBSENSE": true }, "sessionResponse": null, "target": "sucess" }
    // let respObj = res.response;
    // this.buyingPowerGrid = respObj.marginStatementlist[0];

    // let totalBuyingPower = this.buyingPowerGrid.closingClearedCash + this.buyingPowerGrid.marginReleased +
    //   this.buyingPowerGrid.creditAgainstStock + this.buyingPowerGrid.marginUsage;

    // let totalMargins = totalBuyingPower + this.buyingPowerGrid.againstStocks;
    this.textAlign = ["left", "right", "right", "right"];
  if(this.marginSelected == 1){
    this.tableRows =
    [{ rowId: "1", columns: ["BuyingPowerSummaryLabel.CurrentBalance", this.filter.formatTwoDecimal(this.buyingPowerGrid.closingClearedCash)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "2", columns: ["BuyingPowerSummaryLabel.BuyingPowerSources", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginReleased)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "3", columns: ["BuyingPowerSummaryLabel.EquitySaleProceeds", this.filter.formatTwoDecimal(this.buyingPowerGrid.equitySalesProceed)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "4", columns: ["BuyingPowerSummaryLabel.EquityTradingGains", this.filter.formatTwoDecimal(this.buyingPowerGrid.equityTradingGains)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "5", columns: ["BuyingPowerSummaryLabel.DebtSaleProceeds", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtSalesProceed)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "6", columns: ["BuyingPowerSummaryLabel.DebtTradingGains", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtTradingGains)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
   // { rowId: "7", columns: ["BuyingPowerSummaryLabel.DerivativeTradinggains", this.filter.formatTwoDecimal(this.buyingPowerGrid.futureTradingGains)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    //{ rowId: "8", columns: ["BuyingPowerSummaryLabel.OptionPremiumReceived", this.filter.formatTwoDecimal(this.buyingPowerGrid.optionPremiumRcvd)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "7", columns: ["BuyingPowerSummaryLabel.CreditAgainstTodaysStockSale", this.filter.formatTwoDecimal(this.buyingPowerGrid.stocksale)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: true, params: "equityMarginDetail" },
    { rowId: "8", columns: ["BuyingPowerSummaryLabel.AdditionalCredits", this.filter.formatTwoDecimal(this.buyingPowerGrid.creditAgainstStock)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "9", columns: ["BuyingPowerSummaryLabel.StockMargin", this.filter.formatTwoDecimal(this.buyingPowerGrid.againstStocks)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "10", columns: ["BuyingPowerSummaryLabel.BuyingPowerUsed", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginUsage)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "11", columns: ["BuyingPowerSummaryLabel.EquityPurchase", this.filter.formatTwoDecimal(this.buyingPowerGrid.equityPurchase)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "12", columns: ["BuyingPowerSummaryLabel.EquityTradingLosses", this.filter.formatTwoDecimal(this.buyingPowerGrid.equityTradingLosses)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "13", columns: ["BuyingPowerSummaryLabel.DebtPurchase", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtPurchase)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "14", columns: ["BuyingPowerSummaryLabel.DebtTradingLosses", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtTradingLosses)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
   // { rowId: "17", columns: ["BuyingPowerSummaryLabel.DerivativeTradinglosses", this.filter.formatTwoDecimal(this.buyingPowerGrid.foTradingLosses)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
   // { rowId: "18", columns: ["BuyingPowerSummaryLabel.OptionPremiumpaid", this.filter.formatTwoDecimal(this.buyingPowerGrid.optionPremiumsPaid)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "15", columns: ["BuyingPowerSummaryLabel.BuyingPowerHeldtowardsTradingPositions", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: true, params: "equityMarginDetail" },
    { rowId: "16", columns: ["BuyingPowerSummaryLabel.MarginHeldEquity", this.filter.formatTwoDecimal(this.buyingPowerGrid.equityMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "17", columns: ["BuyingPowerSummaryLabel.MarginHeldDebt", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
   // { rowId: "22", columns: ["BuyingPowerSummaryLabel.MarginHeldEquityDerivatives", this.filter.formatTwoDecimal(this.buyingPowerGrid.foMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
   // { rowId: "23", columns: ["BuyingPowerSummaryLabel.BuyingPowerHeldtowardsDerTradingPositions", this.filter.formatTwoDecimal(this.buyingPowerGrid.foMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: true, params: "equityDerMarginDetail"},
    { rowId: "18", columns: ["BuyingPowerSummaryLabel.Margins", this.filter.formatTwoDecimal(this.buyingPowerGridMarginVal)], textAlign: this.textAlign, textIndent: ["200px", "0px"], labelLink: false },
    { rowId: "19", columns: ["BuyingPowerSummaryLabel.BuyingPower", this.filter.formatTwoDecimal(this.buyingPowerGridBuyingVal)], textAlign: this.textAlign, textIndent: ["200px", "0px"], labelLink: false }];
  }else if(this.marginSelected == 2){
    this.tableRows =
    [{ rowId: "1", columns: ["BuyingPowerSummaryLabel.CurrentBalance", this.filter.formatTwoDecimal(this.buyingPowerGrid.closingClearedCash)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "2", columns: ["BuyingPowerSummaryLabel.BuyingPowerSources", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginReleased)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "3", columns: ["BuyingPowerSummaryLabel.CommodityTradingGains", this.filter.formatTwoDecimal(this.buyingPowerGrid.commodityTradingGains)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "4", columns: ["BuyingPowerSummaryLabel.OptionPremiumReceived", this.filter.formatTwoDecimal(this.buyingPowerGrid.optionPremiumRcvd)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "5", columns: ["BuyingPowerSummaryLabel.CreditAgainstTodaysStockSale", this.filter.formatTwoDecimal(this.buyingPowerGrid.stocksale)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "6", columns: ["BuyingPowerSummaryLabel.AdditionalCredits", this.filter.formatTwoDecimal(this.buyingPowerGrid.creditAgainstStock)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "7", columns: ["BuyingPowerSummaryLabel.StockMargin", this.filter.formatTwoDecimal(this.buyingPowerGrid.againstStocks)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "8", columns: ["BuyingPowerSummaryLabel.BuyingPowerUsed", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginUsage)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "9", columns: ["BuyingPowerSummaryLabel.CommodityTradinglosses", this.filter.formatTwoDecimal(this.buyingPowerGrid.commodityTradingLosses)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "10", columns: ["BuyingPowerSummaryLabel.OptionPremiumpaid", this.filter.formatTwoDecimal(this.buyingPowerGrid.optionPremiumsPaid)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "11", columns: ["BuyingPowerSummaryLabel.BuyingPowerHeldtowardsComTradingPositions", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: true, params: "commodityDerMarginDetail" },
    { rowId: "12", columns: ["BuyingPowerSummaryLabel.MarginHeldCommodity", this.filter.formatTwoDecimal(this.buyingPowerGrid.commodityMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "13", columns: ["BuyingPowerSummaryLabel.Margins", this.filter.formatTwoDecimal(this.buyingPowerGridMarginVal)], textAlign: this.textAlign, textIndent: ["200px", "0px"], labelLink: false },
    { rowId: "14", columns: ["BuyingPowerSummaryLabel.BuyingPower", this.filter.formatTwoDecimal(this.buyingPowerGridBuyingVal)], textAlign: this.textAlign, textIndent: ["200px", "0px"], labelLink: false }
  ]

  }else if(this.marginSelected == 3){
    this.tableRows =
    [{ rowId: "1", columns: ["BuyingPowerSummaryLabel.CurrentBalance", this.filter.formatTwoDecimal(this.buyingPowerGrid.closingClearedCash)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "2", columns: ["BuyingPowerSummaryLabel.BuyingPowerSources", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginReleased)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "3", columns: ["BuyingPowerSummaryLabel.EqderivativeTradingGains", this.filter.formatTwoDecimal(this.buyingPowerGrid.commodityTradingGains)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "4", columns: ["BuyingPowerSummaryLabel.OptionPremiumReceived", this.filter.formatTwoDecimal(this.buyingPowerGrid.optionPremiumRcvd)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "5", columns: ["BuyingPowerSummaryLabel.CreditAgainstTodaysStockSale", this.filter.formatTwoDecimal(this.buyingPowerGrid.stocksale)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "6", columns: ["BuyingPowerSummaryLabel.AdditionalCredits", this.filter.formatTwoDecimal(this.buyingPowerGrid.creditAgainstStock)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "7", columns: ["BuyingPowerSummaryLabel.StockMargin", this.filter.formatTwoDecimal(this.buyingPowerGrid.againstStocks)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "8", columns: ["BuyingPowerSummaryLabel.BuyingPowerUsed", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginUsage)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
    { rowId: "9", columns: ["BuyingPowerSummaryLabel.EqderivativeTradinglosses", this.filter.formatTwoDecimal(this.buyingPowerGrid.commodityTradingLosses)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "10", columns: ["BuyingPowerSummaryLabel.OptionPremiumpaid", this.filter.formatTwoDecimal(this.buyingPowerGrid.optionPremiumsPaid)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "11", columns: ["BuyingPowerSummaryLabel.BuyingPowerHeldtowardsDerTradingPositions", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: true, params: "equityDerMarginDetail" },
    { rowId: "12", columns: ["BuyingPowerSummaryLabel.MarginHeldEquityDerivatives", this.filter.formatTwoDecimal(this.buyingPowerGrid.commodityMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
    { rowId: "13", columns: ["BuyingPowerSummaryLabel.Margins", this.filter.formatTwoDecimal(this.buyingPowerGridMarginVal)], textAlign: this.textAlign, textIndent: ["200px", "0px"], labelLink: false },
    { rowId: "14", columns: ["BuyingPowerSummaryLabel.BuyingPower", this.filter.formatTwoDecimal(this.buyingPowerGridBuyingVal)], textAlign: this.textAlign, textIndent: ["200px", "0px"], labelLink: false }
  ]

  }
    
   /* this.tableRows =
      [{ rowId: "1", columns: ["BuyingPowerSummaryLabel.CurrentBalance", this.filter.formatTwoDecimal(this.buyingPowerGrid.closingClearedCash)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
      { rowId: "2", columns: ["BuyingPowerSummaryLabel.BuyingPowerSources", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginReleased)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
      { rowId: "3", columns: ["BuyingPowerSummaryLabel.EquitySaleProceeds", this.filter.formatTwoDecimal(this.buyingPowerGrid.equitySalesProceed)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "4", columns: ["BuyingPowerSummaryLabel.EquityTradingGains", this.filter.formatTwoDecimal(this.buyingPowerGrid.equityTradingGains)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "5", columns: ["BuyingPowerSummaryLabel.DebtSaleProceeds", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtSalesProceed)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "6", columns: ["BuyingPowerSummaryLabel.DebtTradingGains", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtTradingGains)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "7", columns: ["BuyingPowerSummaryLabel.DerivativeTradinggains", this.filter.formatTwoDecimal(this.buyingPowerGrid.futureTradingGains)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "8", columns: ["BuyingPowerSummaryLabel.OptionPremiumReceived", this.filter.formatTwoDecimal(this.buyingPowerGrid.optionPremiumRcvd)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "9", columns: ["BuyingPowerSummaryLabel.CreditAgainstTodaysStockSale", this.filter.formatTwoDecimal(this.buyingPowerGrid.stocksale)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: true, params: "equityMarginDetail" },
      { rowId: "10", columns: ["BuyingPowerSummaryLabel.AdditionalCredits", this.filter.formatTwoDecimal(this.buyingPowerGrid.creditAgainstStock)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
      { rowId: "11", columns: ["BuyingPowerSummaryLabel.StockMargin", this.filter.formatTwoDecimal(this.buyingPowerGrid.againstStocks)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
      { rowId: "12", columns: ["BuyingPowerSummaryLabel.BuyingPowerUsed", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginUsage)], textAlign: this.textAlign, textIndent: ["0px", "0px"], labelLink: false },
      { rowId: "13", columns: ["BuyingPowerSummaryLabel.EquityPurchase", this.filter.formatTwoDecimal(this.buyingPowerGrid.equityPurchase)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "14", columns: ["BuyingPowerSummaryLabel.EquityTradingLosses", this.filter.formatTwoDecimal(this.buyingPowerGrid.equityTradingLosses)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "15", columns: ["BuyingPowerSummaryLabel.DebtPurchase", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtPurchase)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "16", columns: ["BuyingPowerSummaryLabel.DebtTradingLosses", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtTradingLosses)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "17", columns: ["BuyingPowerSummaryLabel.DerivativeTradinglosses", this.filter.formatTwoDecimal(this.buyingPowerGrid.foTradingLosses)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "18", columns: ["BuyingPowerSummaryLabel.OptionPremiumpaid", this.filter.formatTwoDecimal(this.buyingPowerGrid.optionPremiumsPaid)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "19", columns: ["BuyingPowerSummaryLabel.BuyingPowerHeldtowardsTradingPositions", this.filter.formatTwoDecimal(this.buyingPowerGrid.marginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: true, params: "equityMarginDetail" },
      { rowId: "20", columns: ["BuyingPowerSummaryLabel.MarginHeldEquity", this.filter.formatTwoDecimal(this.buyingPowerGrid.equityMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "21", columns: ["BuyingPowerSummaryLabel.MarginHeldDebt", this.filter.formatTwoDecimal(this.buyingPowerGrid.debtMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "22", columns: ["BuyingPowerSummaryLabel.MarginHeldEquityDerivatives", this.filter.formatTwoDecimal(this.buyingPowerGrid.foMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: false },
      { rowId: "23", columns: ["BuyingPowerSummaryLabel.BuyingPowerHeldtowardsDerTradingPositions", this.filter.formatTwoDecimal(this.buyingPowerGrid.foMarginHeld)], textAlign: this.textAlign, textIndent: ["25px", "0px"], labelLink: true, params: "equityDerMarginDetail"},
      { rowId: "24", columns: ["BuyingPowerSummaryLabel.Margins", this.filter.formatTwoDecimal(this.buyingPowerGridMarginVal)], textAlign: this.textAlign, textIndent: ["200px", "0px"], labelLink: false },
      { rowId: "25", columns: ["BuyingPowerSummaryLabel.BuyingPower", this.filter.formatTwoDecimal(this.buyingPowerGridBuyingVal)], textAlign: this.textAlign, textIndent: ["200px", "0px"], labelLink: false }];
 */ 
    }
  handleSelectedRow(event) {
    //this.selectedRow.emit(event); 
    this.services.modal.dismissAll();
    if(event == "equityMarginDetail"){
    const modalRef = this.services.openModal(gotxModalComponent, 'lg', null, "Equity Position Margin");
  }else if (event == "equityDerMarginDetail"){
    const modalRef = this.services.openModal(gotxModalComponent, 'lg', "FUTOPT", "Derivative Position Margin");
  }else if(event == "commodityDerMarginDetail"){
    const modalRef = this.services.openModal(gotxModalComponent, 'lg', "COMDERV", "Derivative Position Margin");
  }

  }

}
